import {
  SET_TELEGRAM_LIST,
} from '../types';

const initialState = {
  telegramRequestsList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TELEGRAM_LIST:
      return {
        ...state,
        telegramRequestsList: action.data,
      };
    default:
      return state;
  }
};
